
import { defineComponent } from 'vue'

import RepoDetailMixin from '~/mixins/repoDetailMixin'
import { Analyzer, AnalyzerEdge } from '~/types/types'

export interface AnalyzerChoice {
  name: string
  shortcode: string
  analyzerLogo?: string
}

export default defineComponent({
  name: 'IssueAnalyzerSelector',
  mixins: [RepoDetailMixin],
  model: {
    prop: 'selectedAnalyzer',
    event: 'updateAnalyzer'
  },
  props: {
    selectedAnalyzer: {
      type: String,
      default: 'all'
    }
  },
  mounted(): void {
    this.$socket.$on('repo-analysis-updated', this.refetchAnalyzers)
  },
  beforeDestroy(): void {
    this.$socket.$off('repo-analysis-updated', this.refetchAnalyzers)
  },
  async fetch(): Promise<void> {
    // Separate query later
    await this.fetchAvailableAnalyzers(this.baseRouteParams)
  },
  computed: {
    modelValue: {
      get(): string {
        return this.selectedAnalyzer
      },
      set(value: string): void {
        this.$emit('updateAnalyzer', value)
      }
    },
    languageFilters(): AnalyzerChoice[] {
      if (this.repository.availableAnalyzers) {
        const { edges } = this.repository.availableAnalyzers
        return edges
          .map((edge) => {
            const node = (edge as AnalyzerEdge).node as Analyzer
            return {
              name: node.name,
              shortcode: node.shortcode,
              analyzerLogo: node.analyzerLogo || ''
            }
          })
          .sort((a: Record<string, string>, b: Record<string, string>) => {
            if (a.shortcode < b.shortcode) {
              return -1
            }
            if (a.shortcode > b.shortcode) {
              return 1
            }
            return 0
          })
      }

      return []
    }
  },
  methods: {
    refetchAnalyzers() {
      this.fetchAvailableAnalyzers({
        ...this.baseRouteParams,
        refetch: true
      })
    }
  }
})
